import { isString } from "lodash-es";

import { RuntimeParseError } from "@/domains/errors";
import { _extractValueFromObject } from "@/modules/object/extractors/extractValue";

export const _extractStringFromObject = (value: unknown, prop: string): string => {
  const extractedValue = _extractValueFromObject(value, prop);

  if (!isString(extractedValue)) {
    throw new RuntimeParseError({
      message: "[_extractStringFromObject] extractedValue was not a string.",
      info: {
        extractedValue,
        value,
        prop,
      },
    });
  }

  return extractedValue;
};
